import { jsx as _jsx } from "react/jsx-runtime";
import { ThemeSpaceVariable, } from '@caspeco/casper-ui-library.base-ui.theme';
import { RadioGroup as ChakraRadioGroup, } from '@chakra-ui/react';
/**
 * Used for multiple radios which are bound in one group, and it indicates which option is selected.
 *
 * @see Docs https://bit.cloud/caspeco/casper-ui-library/components/radio-group
 */
export function RadioGroup({ children, name, isDisabled, defaultValue, value, onChange, display = 'flex', flexDirection = 'column', gap = ThemeSpaceVariable.Medium, ...props }) {
    return (_jsx(ChakraRadioGroup, { name: name, isDisabled: isDisabled, defaultValue: defaultValue, value: value, onChange: onChange, display: display, flexDirection: flexDirection, gap: gap, ...props, children: children }));
}
//# sourceMappingURL=radio-group.js.map